import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { getSubjectColor } from '../../styles/colors';
import styles from './LessonChip.module.css';

function LessonChip({ lesson, compact = false, source = 'calendar', onClick, overlay = false }) {
  const prefix = lesson._itemType === 'worksheet' ? 'worksheet' : 'lesson';
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `${prefix}-${lesson.id}`,
    data: { lesson, source },
  });

  // Support both old (lesson.title) and new (lesson.sections.title) data shapes
  const title = lesson.sections?.title || lesson.title;
  const subject = lesson.sections?.subject || lesson.subject;
  const gradeLevel = lesson.sections?.grade_level || lesson.sections?.gradeLevel || lesson.gradeLevel;
  const color = getSubjectColor(subject);

  const style = {
    backgroundColor: color.bg,
    borderLeftColor: color.border,
    color: color.text,
    ...(transform ? { transform: CSS.Translate.toString(transform) } : {}),
    ...(isDragging ? { opacity: 0.3 } : {}),
  };

  if (overlay) {
    return (
      <div
        className={styles.chip}
        style={{
          backgroundColor: color.bg,
          borderLeftColor: color.border,
          color: color.text,
        }}
      >
        <span className={styles.title}>{title}</span>
        {!compact && gradeLevel && (
          <span className={styles.grade}>{gradeLevel}</span>
        )}
      </div>
    );
  }

  return (
    <div
      ref={setNodeRef}
      className={`${styles.chip} ${isDragging ? styles.dragging : ''}`}
      style={style}
      {...attributes}
      {...listeners}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(lesson);
      }}
    >
      <span className={styles.title}>{title}</span>
      {!compact && gradeLevel && (
        <span className={styles.grade}>{gradeLevel}</span>
      )}
    </div>
  );
}

export default LessonChip;
